<div class="row mt-n1">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> {{ title.plural }}
            </div>

            <div class="card-body-grid" *ngIf="cultivosAforosCortes?.length > 0">

                <p-table #tableSearch autoLayout="true" [value]="cultivosAforosCortes" [lazy]="true"
                         rowExpandMode="single" dataKey="IdCultivo"
                         [lazyLoadOnInit]="false" [rowHover]="true"
                         [paginator]="false" [columns]="cols"
                         [rows]="15" sortOrder="0"
                         [totalRecords]="cultivosAforosCortes?.length" [loading]="loading"
                         [ngClass]="displayGridHidden(cultivosAforosCortes)"
                         styleClass="table table-responsive-sm table-sm">

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}"
                                [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='ExpandLink'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                <div *ngIf="col.field==='ExpandLink'" class="btn-group">
                                    <div style="text-align: center;">
                                        <span>
                                            <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData" 
                                                [title]="expanded ? 'Ocultar Cortes' : 'Mostrar cortes'" 
                                                [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                            </a>
                                        </span>
                                    </div>
                                </div>
                                <span *ngIf="col.field === 'Superficie' || col.field === 'KgsProduccionEstimada' || col.field === 'KgsProduccionReal' || col.field === 'KgsProduccionRestante' ">
                                    {{ rowData[col.field] | number:'1.2-5':'es-ES' }}
                                </span>
                                <span *ngIf="col.field !== 'Superficie' && col.field !== 'KgsProduccionEstimada' && col.field !== 'KgsProduccionReal' && col.field !== 'KgsProduccionRestante' && col.field !== 'ExpandLink' ">
                                    {{ rowData[col.field] }}
                                </span>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                        <tr>
                            <td [attr.colspan]="9">
                                <table class="table-subtable">
                                    <ng-container *ngIf="rowData['cortesCultivos'].length === 0">
                                        <tbody>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="8"><div class="empty-grid empty-grid-sm">Cultivo sin cortes</div></td>
                                            </tr>
                                        </tbody>
                                    </ng-container>
                                    <ng-container *ngIf="rowData['cortesCultivos'].length > 0">
                                        <thead class="table-subtable-thead">
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th>&nbsp;</th>
                                                <th>Corte (Kg)</th>
                                                <th>Fecha Corte</th>
                                                <th>Código de Autorización</th>
                                                <th>Almacén</th>
                                                <th>Exportador</th>
                                                <th>Fecha Caducidad</th>
                                                <th>Fecha Borrado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let corte of rowData['cortesCultivos']">
                                                <td>&nbsp;</td>
                                                <td>
                                                    <ng-container *ngIf="hasDeletingAccess && !readonly && canBeDeleted(corte)">
                                                        <button (click)="onDelete(rowData, corte)" [disabled]="actionNotAllowed" type="button" class="btn btn-sm btn-danger" title="Eliminar Corte">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </ng-container>
                                                    <ng-container *ngIf="!canBeDeleted(corte)">
                                                        <button type="button" class="btn btn-sm" disabled title="Corte eliminado">
                                                            <span class="fa fa-archive"></span>
                                                        </button>
                                                    </ng-container>
                                                    <ng-container *ngIf="hasViewAccess">
                                                        <button (click)="onView(rowData, corte)" [disabled]="actionNotAllowed" type="button" class="btn btn-sm btn-danger" title="Consultar Corte">
                                                            <span class="fa fa-eye"></span>
                                                        </button>
                                                    </ng-container>
                                                </td>
                                                <td>{{ corte.KgsAutorizados | number:'1.2-5':'es-ES' }}</td>
                                                <td>{{ corte.FechaCreacion | date:'dd/MM/yyyy HH:mm' }}</td>
                                                <td>{{ corte.Codigo }}</td>
                                                <td>{{ corte.Almacen }}</td>
                                                <td>{{ corte.Exportador }}</td>
                                                <td><span [ngClass]="{ 'caducado': esCorteCaducado(corte.FechaCaducidad) }">{{ corte.FechaCaducidad | date:'dd/MM/yyyy HH:mm' }}</span></td>
                                                <td>{{ corte.FechaBorrado | date:'dd/MM/yyyy HH:mm' }}</td>
                                            </tr>   
                                        </tbody>                                 
                                    </ng-container>
                                </table>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <div class="card-body-detalle">
                    <div *ngIf="cultivosAforosCortes?.length > 0" class="row">
                        <div class="nota-info col-4 me-2 unset-height">
                            <label class="col-form-label"><span class="fa fa-archive me-1"></span>Este icono indica que el corte ha sido eliminado</label>
                        </div>            
                    </div>
                    <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                    <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                </div>

            </div>
        </div>
    </div>
</div>
